import React, { ReactElement, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { RecoilRoot } from 'recoil';
import { GlobalModalProvider } from '@creditsights/styleguide-web';
import Base from './Base';
import './scss/styles.scss';
import { csSyncDataSubject$, SyncDataSubject } from './sharedSubjects';

const QUERY_RETRY_COUNT = 3;

function shouldRetry(failureCount: number, error): boolean {
  return error.response.status !== 404 && failureCount < QUERY_RETRY_COUNT;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: shouldRetry,
    },
  },
});

function Index(): ReactElement {
  useEffect(() => {
    const csSubject = csSyncDataSubject$.subscribe((subject) => {
      switch (subject) {
        case SyncDataSubject.USER_PREFERENCE:
          queryClient.invalidateQueries();
          break;
        default:
          break;
      }
      if (subject) {
        csSyncDataSubject$.next(null);
      }

      return () => {
        csSubject.unsubscribe();
      };
    });
  }, []);

  return (
    <RecoilRoot>
      <QueryClientProvider client={queryClient}>
        <GlobalModalProvider>
          <Base />
        </GlobalModalProvider>
      </QueryClientProvider>
    </RecoilRoot>
  );
}

export default Index;
